import React from 'react'
import strip from 'striptags'
import { FormattedMessage } from 'react-intl'

const inputWrap = (next, e) => {
  next(strip(e.target.value))
}

export default ({
  onSubmit,
  onInput,
  placeholder,
  value,
  disableBtn = false,
  noAutoFocus = false,
  noEnter = false,
  disabled = false,
  children,
  btnTitle,
  ...props
}) => {
  const Component = noEnter ? 'div' : 'form'

  return (
    <Component className='Form' action='.' onSubmit={onSubmit}>
      <input
        type='text'
        className='Form__field'
        value={value || ''}
        placeholder={placeholder}
        onInput={disabled ? undefined : inputWrap.bind(this, onInput)}
        ref={el => { !noAutoFocus && ((el && el.focus) && el.focus()) }}
        {...props}
      />
      {children}
      {!disableBtn && <button type='submit' className='Form__submit' onClick={onSubmit}><FormattedMessage id={btnTitle || 'form.send'} /></button>}
    </Component>
  )
}



// WEBPACK FOOTER //
// ./src/components/Form.jsx